import styled from 'styled-components';
import SafeHyenicSvg from '../../../assets/onboardingNew/homepage/safe-hygienic.svg';

const SafeHyenicNewIcon = styled(SafeHyenicSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`

width: ${props => props.width || '1.7rem'};
height: ${props => props.height || '2.0rem'};
display: flex;
`;

export default SafeHyenicNewIcon;
